import { changeLeaseSort, changeSaleSort } from './query';

export const SET_LEASE_COLUMNS = 'SET_LEASE_COLUMNS';
export function setLeaseColumns(columns) {
  return (dispatch) => {
    dispatch(changeLeaseSort('name asc'));
    dispatch({ columns, type: SET_LEASE_COLUMNS });
  };
}

export const SET_SALE_COLUMNS = 'SET_SALE_COLUMNS';
export function setSaleColumns(columns) {
  return (dispatch) => {
    dispatch(changeSaleSort('name asc'));
    dispatch({ columns, type: SET_SALE_COLUMNS });
  };
}
